// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__5ztZc","fileBtn":"File_fileBtn__2KoPR","closeBtn":"File_closeBtn__3_b6l","fileSelected":"File_fileSelected__2HK5S","disabled":"File_disabled__1jON9"};